'use strict'

function handle(sdk) {
    sdk.__INTERNAL__.triggerOnRender()
}

module.exports = {
    handle
}
